import { IJobPost } from 'common/models';

import { Box, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { JobTypeEnum } from 'common/enums';

export const ApplicationCountCell = ({
  jobPost,
  onView,
}: {
  jobPost: IJobPost;
  onView: () => void;
}) => {
  const applicationCount =
    jobPost.jobType === JobTypeEnum.FullTime ? jobPost.bidCount : '-';

  return (
    <Box>
      <Button
        disabled={Boolean(jobPost.jobType !== JobTypeEnum.FullTime)}
        onClick={onView}
        endIcon={<VisibilityIcon />}
      >
        {applicationCount}
      </Button>
    </Box>
  );
};
